import styled from 'styled-components'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

export const StyledBreadcrumb = styled(Breadcrumb)`
  & .breadcrumb {
    margin: 0;
  }
`
